import * as tile from 'api/tileApi';

export async function getAllColors() {
    try {
        const response = await tile.getAllColors();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des couleurs des tuiles :', error);
        throw new Error('Erreur lors de la récupération des couleurs des tuiles.');
    }
}

export async function upsertUserPreferences(userId, preferences) {
    try {
        const response = await tile.upsertUserPreferences(userId, preferences);
        return response;
    } catch (error) {
        console.error('Erreur lors de la mise à jour des préférences utilisateur :', error);
        throw new Error('Erreur lors de la mise à jour des préférences utilisateur.');
    }
}

export async function getDefaultPreferences(status) {
    try {
        const response = await tile.getDefaultPreferences(status);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des préférences par défaut :', error);
        throw new Error('Erreur lors de la récupération des préférences par défaut.');
    }
}

export async function upsertDefaultPreferences(status, preferences) {
    try {
        const response = await tile.upsertDefaultPreferences(status, preferences);
        return response;
    } catch (error) {
        console.error('Erreur lors de la mise à jour des préférences par défaut :', error);
        throw new Error('Erreur lors de la mise à jour des préférences par défaut.');
    }
}

export async function getDefaultTiles(status, userId) {
    try {
        const response = await tile.getDefaultTiles(status, userId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des tuiles par défaut :', error);
        throw new Error('Erreur lors de la récupération des tuiles par défaut.');
    }
}

export async function getUserPreferences(userId) {
    try {
        const response = await tile.getUserPreferences(userId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des préférences utilisateur :', error);
        throw new Error('Erreur lors de la récupération des préférences utilisateur.');
    }
}

export async function getUnusedTiles(userId) {
    try {
        const response = await tile.getUnusedTiles(userId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des tuiles non utilisées :', error);
        throw new Error('Erreur lors de la récupération des tuiles non utilisées.');
    }
}

export async function getTilesTypeLink() {
    try {
        const response = await tile.getTilesTypeLink();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des tuiles de type link :', error);
        throw new Error('Erreur lors de la récupération des tuiles detype link.');
    }
}

export async function createTileTypeLink(data) {
    try {
        const response = await tile.createTileTypeLink(data);
        return response;
    } catch (error) {
        console.error('Erreur lors de la création de la tuile de type link :', error);
        throw new Error('Erreur lors de la création de la tuile de type link.');
    }
}

export async function deleteTileTypeLink(tileId, userId) {
    try {
        const response = await tile.deleteTileTypeLink(tileId, userId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la suppression de la tuile de type link :', error);
        throw new Error('Erreur lors de la suppression de la tuile de type link.');
    }
}

export async function proposeTile(userId, data) {
    try {
        const response = await tile.proposeTile(userId, data);
        return response;
    } catch (error) {
        console.error('Erreur lors de la proposition de la tuile :', error);
        throw new Error('Erreur lors de la proposition de la tuile.');
    }
}

export async function getTileProposals() {
    try {
        const response = await tile.getTileProposals();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des propositions de tuiles :', error);
        throw new Error('Erreur lors de la récupération des propositions de tuiles.');
    }
}

export async function validateTileProposal(proposalId, userId, tileId) {
    try {
        const response = await tile.validateTileProposal(proposalId, userId, tileId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la validation de la proposition de tuile :', error);
        throw new Error('Erreur lors de la validation de la proposition de tuile.');
    }
}

export async function declineTileProposal(proposalId, userId) {
    try {
        const response = await tile.declineTileProposal(proposalId, userId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la refus de la proposition de tuile :', error);
        throw new Error('Erreur lors de la refus de la proposition de tuile.');
    }
}

export async function getTilesHasNew10D() {
    try {
        const response = await tile.getTilesHasNew10D();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des tuiles avec nouveau il y a 10 jours :', error);
        throw new Error('Erreur lors de la récupération des tuiles avec nouveau il y a 10 jours.');
    }
}

export async function getKamaeScore(email) {
    try {
        const response = await tile.getKamaeScore(email);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération du score Kamae :', error);
        throw new Error('Erreur lors de la récupération du score Kamae.');
    }
}